import axios from '../../router/axios';

const api = process.env.REACT_APP_API_URL;

export const fetchAdminUser = () => async (dispatch) => {
  try {
    const res = await axios.get(`${api}/admin/getAdminUserList`); 
    dispatch({ type: 'GET_ADMIN_USER_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'ADMIN_USER_FAIL', payload: error.response?.data?.message || 'Failed to fetch' });
  }
};

export const addAdminUser = (addAdminData) => async (dispatch) => {
  try {
    const res = await axios.post(`${api}/admin/addAdminUserList`, addAdminData); 
    dispatch({ type: 'CREATE_ADMIN_USER_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'ADMIN_USER_FAIL', payload: error.response?.data?.message || 'Failed to create' });
  }
};

export const updateAdminUser = (editAdminData) => async (dispatch) => {
  try {
    const res = await axios.post(`${api}/admin/editAdminUserList`, editAdminData); 
    dispatch({ type: 'UPDATE_ADMIN_USER_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'ADMIN_USER_FAIL', payload: error.response?.data?.message || 'Failed to update' });
  }
};

export const deleteAdminUser = (delAdminData) => async (dispatch) => {
  try {
    const res = await axios.post(`${api}/admin/deleteAdminUserList`, delAdminData); 
    dispatch({ type: 'DELETE_ADMIN_USER_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'ADMIN_USER_FAIL', payload: error.response?.data?.message || 'Failed to delete' });
  }
};
